export default "__VITE_ASSET__DObUb6Wf__"